import { ImpostazioniGenerali } from 'app/model/impostazioni_generali';
import { ColoreEvento, IColoreEvento } from 'app/model/colore_evento';

import { Component } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-colors',
	templateUrl: './colori.html',
	styleUrls: ['./../opzioni.css']
})

export class ColorsComponent {

	constructor(
		public activeModal: NgbActiveModal,
		public impostazioni: ImpostazioniGenerali
	) { }

	update(evento: ColoreEvento, newValue: IColoreEvento) {
		evento.update(Object.assign({}, newValue));
	}

}



// WEBPACK FOOTER //
// ./src/app/opzioni/colori/colori.ts